
import _Vue from "vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import SituationalAwarenessAlertsControl from '@/components/situational-awareness/SituationalAwarenessAlertsControl.vue';

export const enum SideBarState {
	Closed  = 0,
	Narrow = 1,
	Wide = 2,
}

@Component({
	components: {
		"situational-awareness-alerts": SituationalAwarenessAlertsControl,
	}
})
export default class DesktopLeftSidebar extends Vue {
	@Prop({type: Boolean, default: false})
	private allowWide: boolean;

	@Prop({type: Number, default: 1})
	private startState: number;

	@Prop({type: Array, default: ["fas fa-chevron-right", "fas fa-chevron-left"]})
	private sliderIcon: string[];

	private state: SideBarState = 1;

	private mounted(){
		this.state = this.startState
	}

	private toggleMovement(grow: boolean){
		if(grow){
			if(this.state >= SideBarState.Closed && this.state != SideBarState.Wide){
				this.state++;
			}
		} else {
			if(this.state <= SideBarState.Wide && this.state != SideBarState.Closed){
				this.state--;
			}
		}
	}

	private get isClosed() : boolean {
		return this.state === SideBarState.Closed;
	}

	private get isWide(): boolean {
		return this.state === SideBarState.Wide;
	}

	private get isNarrow(): boolean {
		return this.state === SideBarState.Narrow;
	}
}

